/* useFilterCleanup.ts */

/* React */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* React Redux */
import { useDispatch } from "react-redux";
import {
  disableFilter,
  clearFilterRestriction,
} from "src/redux/features/insights-filter/insightsFilterSlice";

/* Config */
import { availableInsightsFilter } from "src/config/filter";

/* Interfaces */
import { FilterType } from "src/shared/interfaces/insights-filter/InsightsFilter";

const useFilterCleanup = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const visibleFilters: FilterType[] =
      availableInsightsFilter[location.pathname] ?? [];

    const allFilters: FilterType[] =
      Object.values(FilterType);

    const hiddenFilters = allFilters.filter(
      (filterKey) => !visibleFilters.includes(filterKey)
    );

    hiddenFilters.map((key) => {
      dispatch(disableFilter(key));
    });

    visibleFilters.map((key) => {
      dispatch(clearFilterRestriction(key));
    });
  }, [location.pathname, dispatch]);
};

export default useFilterCleanup;
